export default __webpack_public_path__ + "static/tula-f2ca9d23885d9b7b8d6afa862308d5d8.jpg";